export const currencyMap: Record<
	string,
	{ symbol: string; position: "prefix" | "suffix" }
> = {
	SEK: { symbol: "kr", position: "suffix" },
	EUR: { symbol: "€", position: "prefix" },
	USD: { symbol: "$", position: "prefix" },
	GBP: { symbol: "£", position: "prefix" }
};

/**
 * A price with its currency symbol, decimals kept as Norce returns them so the
 * figure matches the one at checkout. An unknown currency shows its code first.
 */
export const formatPriceWithSymbol = (
	price: number,
	currencyCode: string | undefined
): string => {
	const { symbol, position } = (currencyCode && currencyMap[currencyCode]) || {
		symbol: currencyCode ?? "",
		position: "prefix"
	};
	const amount = Number.isInteger(price) ? price : price.toFixed(2);
	return position === "prefix" ? `${symbol} ${amount}` : `${amount} ${symbol}`;
};
